import React from 'react';
import { Form } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import { SALE_OPTIONS_ALLOW_TYPE_SALE_FIELD, SALE_OPTIONS_FORM } from '../../reducers/features';

const SaleOptionsRadio = ({ inputs, dispatch, setFieldValue }) => {
    const intl = useIntl();
    const options = [
        {
            id: 'togetherSale',
            name: intl.formatMessage({ id: 'sell_allow_to_sell_the_tickets_together' }),
        },
        {
            id: 'partialSale',
            name: intl.formatMessage({ id: 'sell_allow_partial_sale_of_tickets' }),
        },
    ];

    return (
        <Form.Group controlId={SALE_OPTIONS_ALLOW_TYPE_SALE_FIELD} className="mb-3">
            <Form.Label>
                <FormattedMessage id="sell_how_do_you_want_to_sell_your_tickets" />
            </Form.Label>
            {options.map((option) => (
                <Form.Check
                    key={option.id}
                    type="radio"
                    id={option.id}
                    name={SALE_OPTIONS_ALLOW_TYPE_SALE_FIELD}
                    label={option.name}
                    value={option.id}
                    checked={inputs[SALE_OPTIONS_ALLOW_TYPE_SALE_FIELD].value === option.id}
                    onChange={(e) => {
                        dispatch(setFieldValue(SALE_OPTIONS_FORM, SALE_OPTIONS_ALLOW_TYPE_SALE_FIELD, e.target.value));
                    }}
                    isInvalid={!inputs[SALE_OPTIONS_ALLOW_TYPE_SALE_FIELD].isValid}
                />
            ))}
            {inputs[SALE_OPTIONS_ALLOW_TYPE_SALE_FIELD].errorMessage && <span className='text-danger'>{inputs[SALE_OPTIONS_ALLOW_TYPE_SALE_FIELD].errorMessage}</span>}
        </Form.Group>
    );
};

export default SaleOptionsRadio;
